import pxToEm from '@shared/components/mixins/shared/pxToEm'
import genericContentItem from '@shared/components/mixins/genericContentItem'

export default {
  name: 'VoucherComponent',
  mixins: [pxToEm, genericContentItem],
  props: {
    voucher: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    voucherValue() {
      return this.voucher.length > 0 ? this.voucher : this.component.content.text
    },
  },
}
